import api from '../utils/api';

export async function listWhatsappCatalogAdmin() {
  const { data } = await api.get('/admin/whatsapp-catalog');
  return data;
}

export async function createWhatsappCatalogSlot(payload) {
  const { data } = await api.post('/admin/whatsapp-catalog', payload);
  return data;
}

export async function updateWhatsappCatalogSlot(id, payload) {
  const { data } = await api.patch(`/admin/whatsapp-catalog/${id}`, payload);
  return data;
}

export async function listWhatsappCatalogMetaTemplates(id) {
  const { data } = await api.get(`/admin/whatsapp-catalog/${id}/meta-templates`);
  return data;
}

export async function createWhatsappCatalogMetaTemplate(id, payload) {
  const { data } = await api.post(
    `/admin/whatsapp-catalog/${id}/meta-templates`,
    payload
  );
  return data;
}
